<template>
  <div>
    <el-row>
      <el-col>
        <el-card>
          <div class="flex-between" slot="header">
            <div class="tui-cardTitle">
              <span>综合评价</span>
            </div>

            <div class="tui-sexTab" style="flex-direction: row">
              <div class="flex-items">
                <el-select
                  style="margin-right: 20px; width: 180px"
                  v-model="allCycleListValue"
                  placeholder="请选择周期"
                  @change="onChangeAllCycle"
                >
                  <el-option
                    v-for="item in allCycleList"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Id"
                  >
                  </el-option>
                </el-select>
                <el-select
                  style="width: 180px"
                  v-model="allClassListValue"
                  placeholder="请选择班级"
                  @change="onClickAllclass"
                >
                  <el-option
                    v-for="item in allClassList"
                    :key="item.GradeNameAndClassName"
                    :label="item.GradeNameAndClassName"
                    :value="item.Id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div
                class="tui-sexTabItem tui-margin"
                @click="onClickAllStudent(index)"
                :class="
                  allStudentListIndex == index ? 'tui-sexTabItemActive' : ''
                "
                v-for="(item, index) in allStudentList"
                :key="index"
              >
                {{ item.name }}:（{{ item.value }}人）
              </div>
            </div>
          </div>
          <div class="flex">
            <!-- <div class="tui-healthLeft">
              <div
                class="flex-center"
                v-for="(item, index) in allClassList"
                :key="index"
                @click="onClickAllclass(index)"
                :class="allCurrentIndex == index ? 'tui-healthLeftActive' : ''"
              >
                {{ item.GradeNameAndClassName }}
              </div>
            </div> -->
            <div
              v-for="(list, cc) in allPie"
              :key="cc"
              class="flex-center"
              style="width: 20%"
            >
              <div :id="'allEchartsPie' + cc" class="tuiEcharts"></div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!-- 五个评价切换 -->
    <el-row>
      <el-col>
        <el-card>
          <div class="tui-box">
            <div
              class="tui-box-item"
              v-for="(item, index) in tabs"
              :key="index"
              @click="onClickCurrent(index)"
              :class="currentTab == index ? 'tui-box-active' : ''"
            >
              {{ item }}
            </div>
          </div>
          <el-divider></el-divider>
          <!-- 学期评价筛选条件 -->
          <template v-if="currentTab == 0">
            <First />
          </template>
          <!-- 过程评价 -->
          <template v-if="currentTab == 1">
            <Two />
          </template>
          <!-- 家长评价 -->
          <template v-if="currentTab == 2">
            <Three />
          </template>
          <!-- 主题评价 -->
          <template v-if="currentTab == 3">
            <Four />
          </template>
          <!-- 成长足迹评价 -->
          <template v-if="currentTab == 4">
            <Five />
          </template>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  GetOpenCycleInfoSelectResult,
  GetStudentInfoByClassId,
  GetSchoolEvalInfo,
  GetTeacherClassRoleInfo,
} from "@/api/api.js";
import First from "./components/f1.vue";
import Two from "./components/f2.vue";
import Three from "./components/f3.vue";
import Four from "./components/f4.vue";
import Five from "./components/f5.vue";

export default {
  components: {
    First,
    Two,
    Three,
    Four,
    Five,
  },
  data() {
    return {
      allCycleListValue: null,
      allCycleList: [],
      allStudentListIndex: 0,
      currentIndex: 0,
      allPie: [],
      allClassList: [],
      allCurrentIndex: 0,
      allStudentList: [],
      currentTab: 0,
      tabs: ["学期评价", "过程评价", "家长评价", "主题评价", "成长足迹"],
      tableData: [],
      allClassListValue: null,
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));

    this.GetOpenCycleInfoSelectResult();
    await this.GetStudentInfoByClassId();

    await this.GetSchoolEvalInfo();
  },
  methods: {
    async onClickAllclass() {
      await this.GetStudentInfoByClassId();
      await this.GetSchoolEvalInfo();
    },
    onClickCurrent(index) {
      this.currentTab = index;
    },
    // 获取幼儿下拉数据
    async GetTeacherClassRoleInfo() {
      let xhr = await GetTeacherClassRoleInfo();
      let themeArr = [];
      let classArr = [];
      if (this.userInfo.UserIdentity == "1") {
        classArr.push({
          GradeNameAndClassName: "全园",
          ClassName: "全园",
          GradeName: "全园",
          Id: 0,
        });
        this.allClassListValue = 0;
      }
      if (xhr.data.success) {
        xhr.data.response.forEach((Gradeitem) => {
          Gradeitem.ClassInfo.forEach((classItem) => {
            classArr.push({
              GradeNameAndClassName:
                Gradeitem.GradeName + (classItem.Name ? classItem.Name : ""),
              ClassName: classItem.Name ? classItem.Name : "",
              Id: classItem.Id,
              ...Gradeitem,
            });
          });
        });

        switch (this.currentTab) {
          case 0:
            this.classList = classArr;
            this.classId = this.classList[0].Id;
            break;
        }
        this.allClassList = classArr;
      }

      // this.classListTheme = themeArr;
      // //console.log(this.classListTheme);
    },
    // 周期
    async GetOpenCycleInfoSelectResult() {
      let res = await GetOpenCycleInfoSelectResult({
        SchoolId: this.userInfo.SchoolId,
      });
      if (res.data.success) {
        this.allCycleList = res.data.response;
      }
    },
    async GetStudentInfoByClassId() {
      let res = await GetStudentInfoByClassId({
        Id: this.allClassListValue ? this.allClassListValue : 0,
      });
      if (res.data.success) {
        this.allStudentList = res.data.response;
      }
    },
    async onChangeAllCycle(e) {
      this.allCycleListValue = e;
      await this.GetTeacherClassRoleInfo();
      await this.GetStudentInfoByClassId();
      await this.GetSchoolEvalInfo();
    },
    onClickAllStudent(index) {
      this.allStudentListIndex = index;
      this.GetSchoolEvalInfo();
    },
    // 综合评价
    async GetSchoolEvalInfo() {
      let res = await GetSchoolEvalInfo({
        SexType: this.allStudentListIndex,
        ClassId: this.allClassListValue ? this.allClassListValue : 0,
        CycleId: this.allCycleListValue,
      });
      if (res.data.success) {
        this.allPie = res.data.response;
        setTimeout(() => {
          for (let index = 0; index < res.data.response.length; index++) {
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(
              document.getElementById("allEchartsPie" + index)
            );
            // 绘制图表
            myChart.setOption({
              title: {
                text: res.data.response[index].Name,
                x: "center",
                y: "bottom",
                textStyle: {
                  //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
                  fontSize: 18,
                  color: "#666",
                },
              },
              tooltip: {
                // trigger 设置触发类型，默认数据触发，可选值：'item' ¦ 'axis'
                // trigger: "item",
                // formatter: "{a} <br/>{b} : {c}个 ({d}%)",
                show: true,

                textStyle: {
                  color: "#fff",
                  fontFamily: "PingFang SC",
                  fontSize: 12,
                },
                padding: 5,
                formatter: "{a} <br/>{b} : {c}个 ({d}%)",
                position: function (point, params, dom, rect, size) {
                  // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                  // 提示框位置
                  var x = 0; // x坐标位置
                  var y = 0; // y坐标位置

                  // 当前鼠标位置
                  var pointX = point[0];
                  var pointY = point[1];
                  // 提示框大小
                  var boxWidth = size.contentSize[0];
                  var boxHeight = size.contentSize[1];

                  // boxWidth > pointX 说明鼠标左边放不下提示框
                  if (boxWidth > pointX) {
                    x = 5;
                  } else {
                    // 左边放的下
                    x = pointX - boxWidth;
                  }

                  // boxHeight > pointY 说明鼠标上边放不下提示框
                  if (boxHeight > pointY) {
                    y = 5;
                  } else {
                    // 上边放得下
                    y = pointY - boxHeight;
                  }
                  return [x, y];
                },
              },

              color: ["#CFA0FF", "#8F9CFD"],
              series: [
                {
                  name: "测评结果",
                  type: "pie",
                  // radius: '50%',  // 设置饼状图大小，100%时，最大直径=整个图形的min(宽，高)
                  radius: ["40%", "50%"],
                  center: ["50%", "50%"], // 设置饼状图位置，第一个百分数调水平位置，第二个百分数调垂直位置
                  avoidLabelOverlap: false, //是否防止标签重叠策略
                  data: res.data.response[index].namevalue,
                  // itemStyle 设置饼状图扇形区域样式
                  labelLine: {
                    show: true,
                    normal: {
                      //设置引导线长度
                      show: true,
                      length: 3,
                    },
                  },
                  itemStyle: {
                    // emphasis：英文意思是 强调;着重;（轮廓、图形等的）鲜明;突出，重读
                    // emphasis：设置鼠标放到哪一块扇形上面的时候，扇形样式、阴影
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                    },
                    normal: {
                      label: {
                        show: true,
                        position: "outer",
                        formatter: "{b}：{c}",
                      },
                    },
                  },
                },
              ],
            });

            window.addEventListener("resize", function () {
              myChart.resize();
            });
          }
        }, 500);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.el-row {
  margin-bottom: 0.25rem;
  &:last-child {
    margin-bottom: 0;
  }
}
.tui-box {
  width: 375px;
  height: 30px;
  background: #e5ebff;
  border-radius: 15px;
  border: 1px solid #cdcdcd;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  .tui-box-item {
    padding: 0 10px;
    height: 100%;
    cursor: pointer;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    flex-shrink: 0;
  }
  .tui-box-active {
    background: #27abf7 !important;
    color: #fff !important;
  }
}
.tui-border {
  width: 100%;
  height: 1px;
  border: 1px solid #ebeef5;
  margin: 0.25rem 0;
}
.tui-bottomTitle {
  font-size: 0.25rem;
  font-weight: 500;
  text-align: left;
}
.tui-margin {
  margin: 0 0 0 0.25rem !important;
}
.tui-nutrition {
  font-size: 0.2rem;
  color: #333;
  font-weight: bold;
  padding-top: 1rem;
  padding-left: 1.325rem;
  span {
    font-size: 0.45rem;
    color: #e02020;
    font-weight: bold;
    padding-left: 0.275rem;
  }
}
.box-card {
  height: 4.375rem;
}
.tui-details {
  position: absolute;
  bottom: 0.25rem;
  right: 0.25rem;
  display: flex;
  align-items: center;
  color: #4083fe;
  font-size: 0.175rem;
}
.tui-sexTab {
  display: flex;
  flex-direction: column;
  .tui-sexTabItem {
    width: 116px;
    height: 30px;
    border-radius: 3px;
    border: 1px solid #cdcdcd;
    font-size: 14px;
    color: #333;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0 20px 0;
    cursor: pointer;
  }
  .tui-sexTabItemActive {
    background: #cbd6ff;
    font-weight: bold !important;
  }
}
.tui-healthLeft::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.tui-healthLeft::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #9d9d9d;
  opacity: 1;
}

.tui-healthLeft::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
.tui-healthLeftActive {
  background: #cbd6ff;
}
.tui-healthLeft {
  width: 1.875rem;
  height: 2.825rem;
  border-radius: 0.1875rem;
  border: 1px solid #cdcdcd;
  overflow-y: scroll;
  div {
    cursor: pointer;
    width: 1.2375rem;
    height: 0.3375rem;
    font-size: 0.175rem;
    font-weight: 500;
    color: #333;
    margin: 0.25rem auto;
    // padding: 0.25rem 0;
    text-align: center;
    border-radius: 0.25rem;
  }
}
.tui-cardTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.275rem;
  font-family: Bood;
  color: #333;
}
.tui-right {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  .tui-rightItem {
    width: calc(100% / 5);
    display: flex;
    align-items: center;
    margin-left: 0.625rem;
    img {
      width: 0.825rem;
      height: 0.825rem;
    }
    .tui-rightItemBox {
      flex-direction: column;
      padding-left: 0.325rem;
      .tui-Num {
        font-size: 0.5625rem;
        font-weight: 500;
        color: #333;
      }
      .tui-desc {
        font-size: 0.225rem;
        font-weight: 500;
        color: #333;
        padding-top: 0.175rem;
      }
    }
  }
}
.tui-left {
  width: 25%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .tui-leftContent {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .tui-leftTitle {
      font-size: 0.25rem;
      color: #333;
      font-family: Bood;
      padding-bottom: 0.6625rem;
    }
    .tui-leftBtn {
      width: 0.9rem;
      height: 0.4125rem;
      background: linear-gradient(172deg, #f0f3ff 0%, #d4ddff 100%);
      box-shadow: inset 0px 1px 3px 0px rgba(255, 255, 255, 1);
      border-radius: 0.2125rem;
      border: 1px solid #0b22b3;
      font-size: 0.25rem;
      color: #0b22b3;
      font-weight: 500;
    }
    .tui-leftDesc {
      font-size: 0.175rem;
      font-weight: 500;
      padding-top: 0.125rem;
    }
  }
}
.tuiEcharts {
  width: 200px;
  height: 200px;
}
</style>